import { DefaultState } from 'store/reducers/types';

export const READ_TASKS_DATA_REQUEST = "READ_TASKS_DATA_REQUEST";
export const READ_TASKS_DATA_SUCCESS = "READ_TASKS_DATA_SUCCESS";
export const READ_TASKS_DATA_FAILURE = "READ_TASKS_DATA_FAILURE";

export interface TasksData {
  today: number;
  overdue: number;
};

export type TasksState = DefaultState & {
  contents?: TasksData;
};

interface ReadTasksDataRequest {
  type: typeof READ_TASKS_DATA_REQUEST;
};

interface ReadTasksDataSuccess {
  type: typeof READ_TASKS_DATA_SUCCESS;
  contents: TasksData;
}

interface ReadTasksDataFailure {
  type: typeof READ_TASKS_DATA_FAILURE;
}

export type TasksActionTypes = ReadTasksDataRequest | ReadTasksDataSuccess | ReadTasksDataFailure;